import { OrderEditScreen } from "./order-edit.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const OrderEditRoutes: RouteDefinition[] = [
	{
		path: Paths.orders.withIdPlaceholder().edit.path,
		element: <OrderEditScreen />,
		requiredPermissions: [
			"UserInAccountPermission_OrderAdmin_Read",
			"UserInAccountPermission_OrderAdmin_Modify",
		],
	},
];
